import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default {
  // 获取意见反馈
  feedbackList(data) {
    const params = data
    return request({
      url: urlParams + '/feedback/list',
      type: 'get',
      params: params
    })
  }, 
  // 获取意见反馈处理
  feedbackhandle(data) {
    const params = data
    return request({
      url: urlParams + '/feedback/handle',
      type: 'post',
      params: params
    })
  },  
  //删除意见反馈处理
  feedbackDel(data) {
    const params = data
    return request({
      url: urlParams + '/feedback/del',
      type: 'post',
      params: params
    })
  },
  // 获取意见反馈未处理状态
  feedbackuntreatedCount(data) {
    const params = data
    return request({
      url: urlParams + '/feedback/untreatedCount',
      type: 'get',
      params: params
    })
  },     
  // 获取工单列表
  orderWorkList(data) {
    const params = data
    return request({
      url: urlParams + '/order-work/list',
      type: 'get',
      params: params
    })
  },  
  //删除工单
  orderWorkDdel(data) {
    const params = data
    return request({
      url: urlParams + '/order-work/del',
      type: 'post',
      params: params
    })
  }, 
  //完成工单
  orderWorkComplete(data) {
    const params = data
    return request({
      url: urlParams + '/order-work/complete',
      type: 'post',
      params: params
    })
  }, 
  //工单详情
  orderWorkDetail(data) {
    const params = data
    return request({
      url: urlParams + '/order-work/detail',
      type: 'get',
      params: params
    })
  },
  // 添加工单
  orderWorkAdd(data) {
    const params = data
    return request({
      url: urlParams + '/order-work/add',
      type: 'post',
      params: params,
      qs:false
    })
  },  
  // 取消工单
  orderWorkAddCancel(data) {
    const params = data
    return request({
      url: urlParams + '/order-work/cancel',
      type: 'post',
      params: params
    })
  },   
  // 工单分类管理
  orderWorkCategoryList(data) {
    const params = data
    return request({
      url: urlParams + '/order-work-category/list',
      type: 'get',
      params: params
    })
  },    
  // 工单分类添加
  orderWorkCategoryAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/order-work-category/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  }, 
  // 工单分类删除
  orderWorkCategoryDel(data) {
    const params = data
    return request({
      url: urlParams + '/order-work-category/del',
      type: 'post',
      params: params
    })
  },  
  // 工单评价列表
  orderWorkEvaluateList(data) {
    const params = data
    return request({
      url: urlParams + '/order-work-evaluate/list',
      type: 'get',
      params: params
    })
  },  
  // 派单类型总列表
  dispatchOrderClassAllList(data) {
    const params = data
    return request({
      url: urlParams + '/dispatch-order-category/totalList',
      type: 'get',
      params: params
    })
  },  
  // 派单类型列表
  dispatchOrderClassList(data) {
    const params = data
    return request({
      url: urlParams + '/dispatch-order-category/list',
      type: 'get',
      params: params
    })
  }, 
  // 派单类型新增
  dispatchOrderClassAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/dispatch-order-category/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },  
  // 派单类型删除
  dispatchOrderClassDel(data) {
    const params = data
    return request({
      url: urlParams + '/dispatch-order-category/del',
      type: 'post',
      params: params
    })
  },  
  // 派单列表
  dispatchOrderList(data) {
    const params = data
    return request({
      url: urlParams + '/dispatch-order/list',
      type: 'get',
      params: params
    })
  },  
  // 派单列表新增
  dispatchOrderAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/dispatch-order/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  }, 
  // 派单列表删除
  dispatchOrderDel(data) {
    const params = data
    return request({
      url: urlParams + '/dispatch-order/del',
      type: 'post',
      params: params
    })
  },
  // 派单记录列表
  dispatchOrderRecordList(data) {
    const params = data
    return request({
      url: urlParams + '/dispatch-order-record/list',
      type: 'get',
      params: params
    })
  },  
  // 工单分发
  orderWorkDistribute(data) {
    const params = data
    return request({
      url: urlParams + '/order-work/distribute',
      type: 'post',
      params: params
    })
  }, 
  // 工单详情
  order_workmanageOrderDetail(data) {
    const params = data
    return request({
      url: urlParams + '/order-work/manageOrderDetail',
      type: 'post',
      params: params
    })
  },     
  
  //价目列表
  orderWorkCategoryPriceList(data) {
    const params = data
    return request({
      url: urlParams + '/order-work-category-price/list',
      type: 'get',
      params: params
    })
  },
  //价目添加
  orderWorkCategoryPriceAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/order-work-category-price/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },
  //价目删除
  orderWorkCategoryPriceDel(data) {
    const params = data
    return request({
      url: urlParams + '/order-work-category-price/del',
      type: 'post',
      params: params
    })
  },
  
  //价目总列表
  orderWorkCategoryPriceAllList(data) {
    const params = data
    return request({
      url: urlParams + '/order-work-category-price/totalList',
      type: 'get',
      params: params
    })
  },

  
  orderWorkCategoryPriceSort(data) {
    const params = data
    return request({
      url: urlParams + '/order-work-category-price/sort',
      type: 'post',
      params: params
    })
  },
}